{
  "Agent ready": "Agent-bereit",
  "Agent state": "Agent-Status",
  "Asking question": "Stellt Frage",
  "Assign to AI": "KI zuweisen",
  "Automation environment ID": "Automatisierungsumgebungs-ID",
  "Automation links": "Automatisierungslinks",
  "Automation setup: %{status}": "Automatisierungseinrichtung: %{status}",
  "Automation status": "Automatisierungsstatus",
  "Blocked": "Blockiert",
  "Claimed": "Beansprucht",
  "Claimed by": "Beansprucht von",
  "Coding": "Programmiert",
  "Complete": "Vollständig",
  "Disabled": "Deaktiviert",
  "Enable AI task assignment": "KI-Aufgabenzuweisung aktivieren",
  "Environment required": "Umgebung erforderlich",
  "Instance": "Instanz",
  "In review": "In Prüfung",
  "Logs": "Logs",
  "Mark agent-ready": "Als agent-bereit markieren",
  "Not under automation": "Nicht unter Automatisierung",
  "Queued": "In Warteschlange",
  "Run": "Lauf",
  "The task was assigned to AI": "Die Aufgabe wurde der KI zugewiesen",
  "TensorBuzz bot": "TensorBuzz-Bot",
  "TensorBuzz command": "TensorBuzz-Befehl",
  "Unknown": "Unbekannt",
  "Verifying": "Überprüft",
  "Waiting for reply": "Wartet auf Antwort",
  "A name is required": "Ein Name ist erforderlich",
  "Auth tokens": "Auth-Tokens",
  "Auth tokens let an AI bot or app act on your behalf through the API. Treat them like passwords — anyone with a token has your access until you revoke it.": "Mit Auth-Tokens können ein KI-Bot oder eine App über die API in deinem Namen handeln. Behandle sie wie Passwörter — wer ein Token besitzt, hat deinen Zugriff, bis du es widerrufst.",
  "Copy token": "Token kopieren",
  "Copy your token now. For your security, it will not be shown again.": "Kopiere dein Token jetzt. Zu deiner Sicherheit wird es nicht erneut angezeigt.",
  "Could not load auth token": "Auth-Token konnte nicht geladen werden",
  "Could not load auth tokens": "Auth-Tokens konnten nicht geladen werden",
  "Created %{date}": "Erstellt am %{date}",
  "Done": "Fertig",
  "Generate auth token": "Auth-Token generieren",
  "Generate new token": "Neues Token generieren",
  "Generate token": "Token generieren",
  "Generate tokens an AI bot or app can use to act on your behalf through the API.": "Generiere Tokens, die ein KI-Bot oder eine App nutzen kann, um über die API in deinem Namen zu handeln.",
  "Generating...": "Wird generiert...",
  "Last used %{date}": "Zuletzt verwendet %{date}",
  "Manage auth tokens": "Auth-Tokens verwalten",
  "Never used": "Nie verwendet",
  "Rename": "Umbenennen",
  "Rename auth token": "Auth-Token umbenennen",
  "Revoke": "Widerrufen",
  "Revoke this auth token? Apps using it will stop working immediately.": "Dieses Auth-Token widerrufen? Apps, die es verwenden, funktionieren sofort nicht mehr.",
  "Select the token above to copy it": "Markiere das Token oben, um es zu kopieren",
  "The auth token was created": "Das Auth-Token wurde erstellt",
  "The auth token was renamed": "Das Auth-Token wurde umbenannt",
  "The auth token was revoked": "Das Auth-Token wurde widerrufen",
  "Token copied to clipboard": "Token in die Zwischenablage kopiert",
  "Token name": "Tokenname",
  "You have no auth tokens yet": "Du hast noch keine Auth-Tokens",
  "Account not found": "Konto nicht gefunden",
  "Account": "Konto",
  "Accounts": "Konten",
  "Awesome Tasks": "Awesome Tasks",
  "Dashboard": "Übersicht",
  "Edit profile": "Profil bearbeiten",
  "Appearance": "Erscheinungsbild",
  "Invoicing": "Abrechnung",
  "Language": "Sprache",
  "Time": "Zeit",
  "Work": "Arbeit",
  "Personalize the app to your preferences": "App nach Vorlieben personalisieren",
  "Profile": "Profil",
  "Settings": "Einstellungen",
  "Settings saved": "Einstellungen gespeichert",
  "Sign in to manage your settings": "Melden Sie sich an, um Ihre Einstellungen zu verwalten",
  "Back to home": "Zurück zur Startseite",
  "Confirm": "Bestätigen",
  "Dark theme": "Dunkles Design",
  "Light theme": "Helles Design",
  "Page not found": "Seite nicht gefunden",
  "The page you were looking for does not exist or has moved.": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
  "Account created": "Konto erstellt",
  "Already have an account? Sign in": "Bereits ein Konto? Anmelden",
  "Back to sign in": "Zurück zur Anmeldung",
  "Create account": "Konto erstellen",
  "Creating...": "Erstellt...",
  "Don't have an account? Sign up": "Noch kein Konto? Registrieren",
  "Password must be at least 6 characters": "Passwort muss mindestens 6 Zeichen lang sein",
  "Sign up": "Registrieren",
  "Sign up failed": "Registrierung fehlgeschlagen",
  "Sign up with your email and a password": "Mit E-Mail und Passwort registrieren",
  "Email and password are required": "E-Mail und Passwort sind erforderlich",
  "Email is required": "E-Mail ist erforderlich",
  "Enter your email and password to continue": "E-Mail und Passwort eingeben, um fortzufahren",
  "Enter your email and we will send you a reset link": "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Reset-Link",
  "Forgot password": "Passwort vergessen",
  "Forgot password?": "Passwort vergessen?",
  "Password reset email sent": "E-Mail zum Zurücksetzen gesendet",
  "Password reset request failed": "Passwort-Zurücksetzen fehlgeschlagen",
  "Send reset link": "Reset-Link senden",
  "Sending...": "Sendet...",
  "Password": "Passwort",
  "Primary organization": "Primäre Organisation",
  "Sign in": "Anmelden",
  "Sign in failed": "Anmeldung fehlgeschlagen",
  "Signed in": "Angemeldet",
  "Signing in...": "Anmelden...",
  "Sign out": "Abmelden",
  "Signed out": "Abgemeldet",
  "Signing out...": "Abmelden...",
  "Created": "Erstellt",
  "Creditor": "Kreditor",
  "Customer": "Kunde",
  "Edit": "Bearbeiten",
  "Edit account": "Konto bearbeiten",
  "Email": "E-Mail",
  "First name": "Vorname",
  "Actions": "Aktionen",
  "Add timelog": "Zeitprotokoll hinzufügen",
  "Apply": "Anwenden",
  "Assigned users": "Zugewiesene Benutzer",
  "Assign user": "Benutzer zuweisen",
  "Attach file": "Datei anhängen",
  "Comment": "Kommentar",
  "Close": "Schließen",
  "Choose a task type.": "Wähle einen Aufgabentyp aus.",
  "Date": "Datum",
  "Column Name": "Spaltenname",
  "Create": "Erstellen",
  "Create New Task": "Neue Aufgabe erstellen",
  "Creating...": "Wird erstellt...",
  "Failed to load autoassigned users": "Automatisch zugewiesene Benutzer konnten nicht geladen werden",
  "Failed to load board": "Board konnte nicht geladen werden",
  "Failed to load members": "Mitglieder konnten nicht geladen werden",
  "Failed to load organization": "Organisation konnte nicht geladen werden",
  "Failed to load project": "Projekt konnte nicht geladen werden",
  "Failed to load task types": "Aufgabentypen konnten nicht geladen werden",
  "Failed to load tasks": "Aufgaben konnten nicht geladen werden",
  "Edit assignment": "Zuweisung bearbeiten",
  "Add to Board": "Zum Board hinzufügen",
  "Board": "Board",
  "Board placement": "Board-Platzierung",
  "Board not found.": "Board nicht gefunden.",
  "Boards": "Boards",
  "Adding Board...": "Board wird hinzugefügt...",
  "Column: %{columnName}": "Spalte: %{columnName}",
  "Loading Boards...": "Boards werden geladen...",
  "Remove Board placement": "Board-Platzierung entfernen",
  "Remove from Board": "Vom Board entfernen",
  "Remove": "Entfernen",
  "Remove this task from %{boardName}?": "Diese Aufgabe von %{boardName} entfernen?",
  "Removing...": "Wird entfernt...",
  "Offline": "Offline",
  "Pending": "Ausstehend",
  "Syncing": "Synchronisierung läuft",
  "Syncing…": "Synchronisiere…",
  "Failed": "Fehlgeschlagen",
  "Conflicted": "Konflikt",
  "Retry": "Erneut versuchen",
  "Search projects and Boards...": "Projekte und Boards suchen...",
  "This task is not on any Boards.": "Diese Aufgabe befindet sich auf keinem Board.",
  "Edit invoice group": "Rechnungsgruppe bearbeiten",
  "Details": "Details",
  "Edit timelog": "Zeitprotokoll bearbeiten",
  "File": "Datei",
  "File not found": "Die Datei wurde nicht gefunden",
  "Open file": "Datei öffnen",
  "Resource": "Ressource",
  "Uploaded by": "Hochgeladen von",
  "Edit project": "Projekt bearbeiten",
  "Edit task": "Aufgabe bearbeiten",
  "Edit user": "Benutzer bearbeiten",
  "Autoassigned users": "Automatisch zugewiesene Benutzer",
  "Invoice group not found": "Rechnungsgruppe nicht gefunden",
  "Invoice groups": "Rechnungsgruppen",
  "Invoices": "Rechnungen",
  "Loading...": "Wird geladen...",
  "Name": "Name",
  "No invoice groups found": "Keine Rechnungsgruppen gefunden",
  "No invoices were linked to this invoice group": "Keine Rechnungen waren mit dieser Rechnungsgruppe verknüpft",
  "No assigned users": "Keine zugewiesenen Benutzer",
  "No users assigned to this task": "Keine Benutzer sind dieser Aufgabe zugewiesen",
  "User added to task": "Benutzer zur Aufgabe hinzugefügt",
  "User removed from task": "Benutzer von der Aufgabe entfernt",
  "You": "Du",
  "Cancel": "Abbrechen",
  "Delete": "Löschen",
  "Delete file": "Datei löschen",
  "No files found": "Keine Dateien gefunden",
  "No invoices found": "Keine Rechnungen gefunden",
  "New account": "Neues Konto",
  "New invoice group": "Neue Rechnungsgruppe",
  "New project": "Neues Projekt",
  "Project": "Projekt",
  "Project not found": "Projekt nicht gefunden",
  "Priority": "Priorität",
  "New task": "Neue Aufgabe",
  "New timelog": "Neues Zeitprotokoll",
  "New Column": "Neue Spalte",
  "New user": "Neuer Benutzer",
  "No accounts found": "Keine Konten gefunden",
  "Not signed in": "Du musst dich anmelden, um fortzufahren",
  "No tasks in this column": "Keine Aufgaben in dieser Spalte",
  "No matching tasks found": "Keine passenden Aufgaben gefunden",
  "State": "Status",
  "Save": "Speichern",
  "Search": "Suchen",
  "All states": "Alle Status",
  "All creditors": "Alle Kreditoren",
  "All debitors": "Alle Debitoren",
  "All invoice types": "Alle Rechnungstypen",
  "Clear filters": "Filter zurücksetzen",
  "Debitor": "Debitor",
  "Refresh": "Aktualisieren",
  "Sort": "Sortierung",
  "Task not found": "Aufgabe nicht gefunden",
  "Time": "Zeit",
  "Timelog": "Zeitprotokoll",
  "Timelog deleted": "Zeitprotokoll gelöscht",
  "Timelog not found": "Zeitprotokoll nicht gefunden",
  "Time transport": "Transportzeit",
  "Time Logs Dashboard": "Zeiterfassungs-Dashboard",
  "More filters": "Weitere Filter",
  "Saving...": "Speichert...",
  "Search accounts...": "Konten suchen...",
  "Invoicing status": "Rechnungsstatus",
  "Invoiced only": "Nur fakturierte",
  "No timelogs found": "Keine Zeitprotokolle gefunden",
  "No timelogs found for this period.": "Für diesen Zeitraum wurden keine Zeiteinträge gefunden.",
  "No previous period": "Kein vorheriger Zeitraum",
  "Uninvoiced only": "Nur nicht fakturierte",
  "Task": "Aufgabe",
  "Task details": "Aufgabendetails",
  "Task ID": "Aufgaben-ID",
  "Task Type": "Aufgabentyp",
  "Task not found on this board.": "Die Aufgabe wurde auf diesem Board nicht gefunden.",
  "Timelogs": "Zeitprotokolle",
  "The assignment was saved": "Die Zuweisung wurde gespeichert",
  "The file was deleted": "Die Datei wurde gelöscht",
  "The timelog was saved": "Das Zeitprotokoll wurde gespeichert",
  "Uploaded files": "Hochgeladene Dateien",
  "Time (minutes)": "Zeit (Minuten)",
  "Time transport (minutes)": "Transportzeit (Minuten)",
  "Transport length": "Transportlänge",
  "Transport length (km)": "Transportlänge (km)",
  "Untitled column": "Unbenannte Spalte",
  "Untitled task": "Unbenannte Aufgabe",
  "Last name": "Nachname",
  "Updated": "Aktualisiert",
  "User": "Benutzer",
  "User not found": "Benutzer nicht gefunden",
  "Organization": "Organisation",
  "Organization not found": "Organisation nicht gefunden",
  "Delete organization": "Organisation löschen",
  "Payment info": "Zahlungsinformationen",
  "Delivery address": "Lieferadresse",
  "Delivery zip code": "Liefer-PLZ",
  "Delivery city": "Lieferstadt",
  "Delivery country": "Lieferland",
  "Invoice address": "Rechnungsadresse",
  "Invoice zip code": "Rechnungs-PLZ",
  "Invoice city": "Rechnungsstadt",
  "Invoice country": "Rechnungsland",
  "VAT no": "USt-IdNr.",
  "Edit organization": "Organisation bearbeiten",
  "New organization": "Neue Organisation",
  "The organization was deleted": "Die Organisation wurde gelöscht",
  "The organization was saved": "Die Organisation wurde gespeichert",
  "Amount": "Betrag",
  "Amount currency": "Währung",
  "Edit invoice line": "Rechnungszeile bearbeiten",
  "Invoice line not found": "Rechnungszeile nicht gefunden",
  "New invoice line": "Neue Rechnungszeile",
  "Quantity": "Menge",
  "The invoice line was saved": "Die Rechnungszeile wurde gespeichert",
  "Title": "Titel",
  "Edit comment": "Kommentar bearbeiten",
  "New comment": "Neuer Kommentar",
  "The comment was saved": "Der Kommentar wurde gespeichert",
  "Comment not found": "Kommentar nicht gefunden",
  "Changed the task status to %{state}": "Aufgabenstatus geändert zu %{state}",
  "Comments": "Kommentare",
  "No comments found": "Keine Kommentare gefunden",
  "Add invoice line": "Rechnungszeile hinzufügen",
  "Amount total": "Gesamtbetrag",
  "Amount VAT": "MwSt.",
  "Amounts": "Beträge",
  "Finish": "Fertigstellen",
  "ID": "ID",
  "Invoice %{number}": "Rechnung %{number}",
  "Invoice lines": "Rechnungszeilen",
  "Invoice no": "Rechnungsnummer",
  "Invoice not found": "Rechnung nicht gefunden",
  "Invoice type": "Rechnungsart",
  "Manage": "Verwalten",
  "More": "Mehr",
  "Mine": "Meine",
  "No": "Nein",
  "No invoice groups": "Keine Rechnungsgruppen",
  "No invoice lines": "Keine Rechnungszeilen",
  "No VAT": "Keine MwSt.",
  "Payment date": "Zahlungsdatum",
  "Register as paid": "Als bezahlt registrieren",
  "Register as sent": "Als gesendet registrieren",
  "All": "Alle",
  "Load more": "Mehr laden",
  "%{count} active members": "%{count} aktive Mitglieder",
  "%{count} assigned": "%{count} zugewiesen",
  "%{count} comments": "%{count} Kommentare",
  "%{count} projects": "%{count} Projekte",
  "%{count} timelogs": "%{count} Zeitprotokolle",
  "Last activity: %{date}": "Letzte Aktivität: %{date}",
  "Manage organizations, customers and creditors": "Organisationen, Kunden und Kreditoren verwalten",
  "No activity yet": "Noch keine Aktivität",
  "No organizations found": "Keine Organisationen gefunden",
  "Organizations": "Organisationen",
  "Search organizations by name...": "Organisationen nach Namen suchen...",
  "Search organizations...": "Organisationen suchen...",
  "Date from": "Datum von",
  "Date range": "Datumsbereich",
  "Date to": "Datum bis",
  "Delete Column": "Spalte löschen",
  "Delete Task": "Aufgabe löschen",
  "Delete the column %{name}?": "Die Spalte %{name} löschen?",
  "Delete this task?": "Diese Aufgabe löschen?",
  "Delete this timelog?": "Dieses Zeitprotokoll löschen?",
  "Manage and track team billable hours": "Verwalten und verfolgen Sie die abrechenbaren Stunden des Teams",
  "Loading dashboard...": "Dashboard wird geladen...",
  "Search by comment...": "Nach Kommentar suchen...",
  "No users found": "Keine Benutzer gefunden",
  "No organization": "Keine Organisation",
  "Search users...": "Benutzer suchen...",
  "Users": "Benutzer",
  "After tax (40%)": "Nach Steuer (40%)",
  "Distance": "Entfernung",
  "Due soon": "Bald fällig",
  "Earned": "Verdient",
  "Entries": "Einträge",
  "Enter a duration like 1h 5m, 30s or 1.5": "Geben Sie eine Dauer wie 1h 5m, 30s oder 1,5 ein",
  "1h 5m, 30s or 1.5": "1h 5m, 30s oder 1,5",
  "Hours": "Stunden",
  "h": "Std.",
  "Invoiced": "Abgerechnet",
  "Billing progress": "Abrechnungsfortschritt",
  "Estimated earnings": "Geschätzter Umsatz",
  "Invoiced %{invoiced} of %{total}%{currency}": "%{invoiced} von %{total}%{currency} abgerechnet",
  "Internal": "Intern",
  "Overview": "Übersicht",
  "Transport": "Transport",
  "Transport earned": "Transporterlös",
  "Total earned": "Insgesamt verdient",
  "Rate": "Satz",
  "Status": "Status",
  "Unknown user": "Unbekannter Benutzer",
  "Unknown date": "Unbekanntes Datum",
  "Untitled entry": "Unbenannter Eintrag",
  "%{amount} %{currency}": "%{amount} %{currency}",
  "%{amount} %{currency}/h": "%{amount} %{currency}/Std.",
  "%{date} · %{user}": "%{date} · %{user}",
  "Active": "Aktiv",
  "Finished": "Fertig",
  "Inactive": "Inaktiv",
  "Browse, search and manage projects": "Projekte durchsuchen und verwalten",
  "Delete project: %{name}?": "Projekt löschen: %{name}?",
  "Members": "Mitglieder",
  "No autoassigned users found": "Keine automatisch zugewiesenen Benutzer gefunden",
  "No members found": "Keine Mitglieder gefunden",
  "No projects found": "Keine Projekte gefunden",
  "No projects yet.": "Noch keine Projekte.",
  "Project deleted": "Projekt gelöscht",
  "Projects": "Projekte",
  "Search projects by name...": "Projekte nach Namen suchen...",
  "Search projects...": "Projekte suchen...",
  "This will also remove the project's boards, tasks, task types and user assignments.": "Dadurch werden auch die Boards, Aufgaben, Aufgabentypen und Benutzerzuweisungen des Projekts entfernt.",
  "Closed": "Geschlossen",
  "No board column": "Keine Boardspalte",
  "No task type": "Kein Aufgabentyp",
  "No tasks found": "Keine Aufgaben gefunden",
  "Unnamed project": "Unbenanntes Projekt",
  "Unnamed task": "Unbenannte Aufgabe",
  "Unnamed task type": "Unbenannter Aufgabentyp",
  "Open": "Offen",
  "Loading board...": "Board wird geladen...",
  "Column": "Spalte",
  "Column actions": "Spaltenaktionen",
  "Status color": "Statusfarbe",
  "Add task": "Aufgabe hinzufügen",
  "Edit Column": "Spalte bearbeiten",
  "Issue title": "Aufgabentitel",
  "Please enter a column name.": "Bitte gib einen Spaltennamen ein.",
  "Please enter a title.": "Bitte gib einen Titel ein.",
  "Add context or acceptance details...": "Füge Kontext oder Akzeptanzkriterien hinzu...",
  "Description": "Beschreibung",
  "e.g. Backlog, In Review": "z. B. Backlog, Im Review",
  "Confirm delete": "Löschen bestätigen",
  "Credit": "Gutschrift",
  "Debit": "Lastschrift",
  "Deleting...": "Wird gelöscht...",
  "Draft": "Entwurf",
  "Edit invoice %{id}": "Rechnung %{id} bearbeiten",
  "Enter details": "Details eingeben",
  "Highest amount": "Höchster Betrag",
  "Invoice number A-Z": "Rechnungsnummer A-Z",
  "Invoice number Z-A": "Rechnungsnummer Z-A",
  "Lowest amount": "Niedrigster Betrag",
  "New invoice": "Neue Rechnung",
  "Newest first": "Neueste zuerst",
  "Name A-Z": "Name A-Z",
  "Name Z-A": "Name Z-A",
  "Oldest first": "Älteste zuerst",
  "Open, confirmed, and waiting": "Offen, bestätigt und wartend",
  "Paid": "Bezahlt",
  "Purchase": "Einkauf",
  "Search invoices...": "Rechnungen suchen...",
  "Sent": "Gesendet",
  "Show": "Anzeigen",
  "State A-Z": "Status A-Z",
  "Type": "Typ",
  "Type A-Z": "Typ A-Z",
  "Search tasks...": "Aufgaben suchen...",
  "Search tasks by name or description...": "Aufgaben nach Name oder Beschreibung suchen...",
  "Task actions": "Aufgabenaktionen",
  "Tasks": "Aufgaben",
  "Task deleted": "Aufgabe gelöscht",
  "Delete task: %{name}?": "Aufgabe löschen: %{name}?",
  "Track and manage tasks across projects": "Aufgaben über Projekte hinweg verfolgen und verwalten",
  "All projects": "Alle Projekte",
  "All users": "Alle Benutzer",
  "Any": "Alle",
  "Daily timelogs aggregated for the selected range": "Tägliche Zeitprotokolle für den gewählten Zeitraum aggregiert",
  "Export CSV": "CSV exportieren",
  "Exporting...": "Exportiert...",
  "Exported %{count} timelogs": "%{count} Zeitprotokolle exportiert",
  "Filter, export and bulk-invoice tracked time": "Erfasste Zeit filtern, exportieren und in Rechnung stellen",
  "Mark all invoiced": "Alle als abgerechnet markieren",
  "Mark all matching timelogs as invoiced?": "Alle übereinstimmenden Zeitprotokolle als abgerechnet markieren?",
  "Marked %{count} timelogs as invoiced": "%{count} Zeitprotokolle als abgerechnet markiert",
  "Marking...": "Markiert...",
  "Not invoiced": "Nicht abgerechnet",
  "Total hours": "Gesamtstunden",
  "Transport hours": "Transportstunden",
  "Invoiced / not invoiced": "Abgerechnet / nicht abgerechnet",
  "Currency": "Währung",
  "Edit invoice": "Rechnung bearbeiten",
  "Work status": "Arbeitsstatus",
  "%{percent} vs %{range}": "%{percent} gegenüber %{range}",
  "%{from} - %{to}": "%{from} - %{to}",
  "Yes": "Ja",
  "Choose file": "Datei auswählen",
  "No file chosen": "Keine Datei ausgewählt",
  "A file upload is required": "Ein Datei-Upload ist erforderlich",
  "Could not load the form": "Das Formular konnte nicht geladen werden",
  "Could not save the bill": "Die Rechnung konnte nicht gespeichert werden",
  "Could not save the file": "Die Datei konnte nicht gespeichert werden",
  "File uploads are only supported on the web": "Datei-Uploads werden nur im Web unterstützt",
  "New file": "Neue Datei",
  "New bill": "Neue Rechnung",
  "New creditor": "Neuer Kreditor",
  "No creditors found": "Keine Kreditoren gefunden",
  "Select creditor": "Kreditor auswählen",
  "Uploaded file": "Hochgeladene Datei",
  "Add uninvoiced timelogs": "Nicht fakturierte Zeitprotokolle hinzufügen",
  "No uploaded files": "Keine hochgeladenen Dateien",
  "Delete invoice": "Rechnung löschen",
  "Delete invoice line": "Rechnungszeile löschen",
  "Delete this invoice?": "Diese Rechnung löschen?",
  "Delete this invoice line?": "Diese Rechnungszeile löschen?",
  "Added %{count} uninvoiced timelogs": "%{count} nicht fakturierte Zeitprotokolle hinzugefügt",
  "Invoice finished": "Rechnung abgeschlossen",
  "Invoice registered as sent": "Rechnung als gesendet markiert",
  "Invoice registered as paid": "Rechnung als bezahlt markiert",
  "PDF": "PDF",
  "The invoice line was deleted": "Die Rechnungszeile wurde gelöscht",
  "Deactivated": "Deaktiviert",
  "Deadline at": "Frist",
  "Delete this user?": "Diesen Benutzer löschen?",
  "Delete user": "Benutzer löschen",
  "Invited": "Eingeladen",
  "Last login: %{date}": "Letzte Anmeldung: %{date}",
  "Member": "Mitglied",
  "Never": "Nie",
  "The user was deleted": "Der Benutzer wurde gelöscht",
  "Add": "Hinzufügen",
  "Add daily work": "Tägliche Arbeit hinzufügen",
  "Add new user role": "Neue Benutzerrolle hinzufügen",
  "Add user": "Benutzer hinzufügen",
  "Are you sure that you want to close this task?": "Möchten Sie diese Aufgabe wirklich schließen?",
  "Are you sure you want to delete this task type?": "Möchten Sie diesen Aufgabentyp wirklich löschen?",
  "Auto-assigned users for %{projectName}": "Automatisch zugewiesene Benutzer für %{projectName}",
  "Choose profile picture": "Profilbild auswählen",
  "Close task": "Aufgabe schließen",
  "Closing...": "Schließt...",
  "Confirmed": "Bestätigt",
  "Could not find the selection callback": "Die Auswahlfunktion konnte nicht gefunden werden",
  "Could not load auto-assigned users": "Automatisch zugewiesene Benutzer konnten nicht geladen werden",
  "Could not load invoices": "Rechnungen konnten nicht geladen werden",
  "Could not load profile": "Profil konnte nicht geladen werden",
  "Could not read the selected image": "Das ausgewählte Bild konnte nicht gelesen werden",
  "Could not load project members": "Projektmitglieder konnten nicht geladen werden",
  "Could not load task types": "Aufgabentypen konnten nicht geladen werden",
  "Could not load user roles": "Benutzerrollen konnten nicht geladen werden",
  "Could not load users": "Benutzer konnten nicht geladen werden",
  "Delete user role": "Benutzerrolle löschen",
  "Edit file": "Datei bearbeiten",
  "Edit user role": "Benutzerrolle bearbeiten",
  "Forbidden": "Verboten",
  "General": "Allgemein",
  "Invoice group": "Rechnungsgruppe",
  "Invoice group id is missing": "Rechnungsgruppen-ID fehlt",
  "Invoice group was not found": "Die Rechnungsgruppe wurde nicht gefunden",
  "Loading invoices...": "Rechnungen werden geladen...",
  "Loading profile...": "Profil wird geladen...",
  "Loading task types...": "Aufgabentypen werden geladen...",
  "Loading tasks...": "Aufgaben werden geladen...",
  "Loading user roles...": "Benutzerrollen werden geladen...",
  "Loading users...": "Benutzer werden geladen...",
  "Members for %{projectName}": "Mitglieder für %{projectName}",
  "Add task type": "Aufgabentyp hinzufügen",
  "New task type": "Neuer Aufgabentyp",
  "No auto-assigned users yet": "Noch keine automatisch zugewiesenen Benutzer",
  "No invoices in this group": "Keine Rechnungen in dieser Gruppe",
  "No members yet": "Noch keine Mitglieder",
  "No more users available to add": "Keine weiteren Benutzer verfügbar",
  "No open tasks": "Keine offenen Aufgaben",
  "No task types found": "Keine Aufgabentypen gefunden",
  "No users match the current filters": "Keine Benutzer entsprechen den Filtern",
  "Owner": "Eigentümer",
  "Password confirmation": "Passwort bestätigen",
  "Passwords do not match": "Passwörter stimmen nicht überein",
  "Please choose an image file": "Bitte wählen Sie eine Bilddatei aus",
  "Please enter a positive number of hours": "Bitte geben Sie eine positive Stundenanzahl ein",
  "Price per hour": "Preis pro Stunde",
  "Price per hour (transport)": "Preis pro Stunde (Transport)",
  "Profile picture": "Profilbild",
  "Remove": "Entfernen",
  "Results": "Ergebnisse",
  "Roles for %{name}": "Rollen für %{name}",
  "Select": "Auswählen",
  "Select user": "Benutzer auswählen",
  "Task type": "Aufgabentyp",
  "Task types": "Aufgabentypen",
  "Task types for %{projectName}": "Aufgabentypen für %{projectName}",
  "The task type was deleted": "Der Aufgabentyp wurde gelöscht",
  "The task was closed": "Die Aufgabe wurde geschlossen",
  "The user has no roles": "Der Benutzer hat keine Rollen",
  "The user role was deleted": "Die Benutzerrolle wurde gelöscht",
  "The user role was saved": "Die Benutzerrolle wurde gespeichert",
  "The work was saved": "Die Arbeit wurde gespeichert",
  "Total": "Gesamt",
  "User added to auto-assignment": "Benutzer zur automatischen Zuweisung hinzugefügt",
  "User added to project": "Benutzer zum Projekt hinzugefügt",
  "User removed from auto-assignment": "Benutzer aus der automatischen Zuweisung entfernt",
  "User removed from project": "Benutzer aus dem Projekt entfernt",
  "User search": "Benutzersuche",
  "User selected": "Benutzer ausgewählt",
  "Waiting": "Wartend",
  "You do not have access to this page": "Sie haben keinen Zugriff auf diese Seite",
  "You must sign in to continue": "Sie müssen sich anmelden, um fortzufahren",
  "Your profile": "Ihr Profil",
  "Your profile was saved": "Ihr Profil wurde gespeichert",
  "haya_select.no_options_found": "Keine Optionen gefunden",
  "haya_select.nothing_selected": "Nichts ausgewählt",
  "haya_select.pagination_page_of_pages": "Seite %{page} von %{totalPages}",
  "haya_select.search_dot_dot_dot": "Suchen...",
  "Conflicts": "Konflikte",
  "Database connection timeout": "Zeitüberschreitung bei der Datenbankverbindung",
  "Last synced": "Zuletzt synchronisiert",
  "Next retry": "Nächster Versuch",
  "Next retry %{date}": "Nächster Versuch %{date}",
  "No network connection": "Keine Netzwerkverbindung",
  "Project sync settings are incomplete": "Projektsynchronisierungseinstellungen sind unvollständig",
  "Queued changes": "Angestandene Änderungen",
  "Reason": "Grund",
  "Rejected changes": "Abgelehnte Änderungen",
  "Sync failed": "Synchronisierung fehlgeschlagen",
  "Sync request rejected": "Synchronisierungsanfrage abgelehnt",
  "Sync sign-in required": "Anmeldung zur Synchronisierung erforderlich",
  "Sync status": "Synchronisierungsstatus",
  "%{count} changes queued": "%{count} Änderungen in Warteschlange",
  "%{count} changes rejected": "%{count} Änderungen abgelehnt",
  "%{count} conflicts": "%{count} Konflikte",
  "%{date} last synced": "Zuletzt synchronisiert %{date}"
}
